import { isMobile } from '../../helpers/isMobile';

export const slotBoardResourceNames = {
  slotBarBoard: 'slotBarBoard',
  background: 'background',
  menuBarPopup: 'menuBarPopup',
};

export const menuBarResourceNames = {
  menuBarPopup: 'menuBarPopup',
};

export const slotBarSymbolNames = {
  star: 'star',
  bell: 'bell',
  plum: 'plum',
  grape: 'grape',
  lemon: 'lemon',
  seven: 'seven',
  cherry: 'cherry',
  orange: 'orange',
  dollar: 'dollar',
  wild: 'wild',
  watermelon: 'watermelon',
  jackpotSymbol: 'jackpotSymbol',
};

export const slotBarSymbolEnums = {
  1: slotBarSymbolNames.seven,
  2: slotBarSymbolNames.bell,
  3: slotBarSymbolNames.grape,
  4: slotBarSymbolNames.watermelon,
  5: slotBarSymbolNames.cherry,
  6: slotBarSymbolNames.plum,
  7: slotBarSymbolNames.orange,
  8: slotBarSymbolNames.lemon,
  9: slotBarSymbolNames.wild,
  10: slotBarSymbolNames.dollar,
  11: slotBarSymbolNames.star,
};

const winBarWinSceneSpineNames = {
  popup: 'popup',
  winPopup: 'winPopup',
  winCoins: 'winCoins',
  wheelLamp: 'wheelLamp',
  wheelIcon: 'wheelIcon',
  lightning: 'lightning',
  jackpotIcon: 'jackpotIcon',
  wheelSpinIcon: 'wheelSpinIcon',
  wheelBlueBoard: 'wheelBlueBoard',
  jackpotActiveColumn: 'jackpotActiveColumn',
  jackpotStartPopup: 'jackpotStartPopup',
  jackpotAmountBoard: 'jackpotAmountBoard',
  jackpotGameSceneBoard: 'jackpotGameSceneBoard',
  jackpotSymbolContainer: 'jackpotSymbolContainer',
  jackpotWinPopupAnimation: 'jackpotWinPopupAnimation',
};

export const webGameImageSprites = {
  webGameImageResources: {
    isNeedResourceForLoading: true,
    name: 'webGameImages',
    path: 'atlases/webGameImages/webGameImages.json',
  },
  boostedJackpot: {
    isNeedResourceForLoading: true,
    name: 'boostedJackpot',
    path: 'atlases/webGameImages/boostedJackpot.json',
  },
  webGameSlotBoardResources: {
    isNeedResourceForLoading: true,
    name: 'slotBoardImages',
    path: 'atlases/webGameImages/slotBoardImages.json',
  },
  introImages: {
    isNeedResourceForLoading: true,
    name: 'introImages',
    path: 'atlases/webGameImages/introImages.json',
  },
  introImages1: {
    isNeedResourceForLoading: true,
    name: 'introImages1',
    path: 'atlases/webGameImages/introImages1.json',
  },

  jackpotImages: {
    isNeedResourceForLoading: true,
    name: 'jackpotImages',
    path: 'atlases/webGameImages/jackpotImages.json',
  },
  introImages2: {
    isNeedResourceForLoading: true,
    name: 'introImages2',
    path: 'atlases/webGameImages/introImages2.json',
  },
  gambleFuture: {
    isNeedResourceForLoading: true,
    name: 'gambleFuture',
    path: 'atlases/webGameImages/gambleFuture.json',
  },
};

export const mobileGameImageSprites = {
  mobileGameImageResources: {
    isNeedResourceForLoading: true,
    name: 'mobileGameImages',
    path: 'atlases/mobileGameImages/mobileGameImages.json',
  },
  boostedJackpot: {
    isNeedResourceForLoading: true,
    name: 'boostedJackpot',
    path: 'atlases/webGameImages/boostedJackpot.json',
  },
  introImages: {
    isNeedResourceForLoading: true,
    name: 'introImages',
    path: 'atlases/mobileGameImages/introImages.json',
  },
  introImages1: {
    isNeedResourceForLoading: true,
    name: 'introImages1',
    path: 'atlases/mobileGameImages/introImages1.json',
  },
  introImages2: {
    isNeedResourceForLoading: true,
    name: 'introImages1',
    path: 'atlases/mobileGameImages/introImages2.json',
  },

  jackpotImages: {
    isNeedResourceForLoading: true,
    name: 'jackpotImages',
    path: 'atlases/mobileGameImages/jackpotImages.json',
  },
  gambleFuture: {
    isNeedResourceForLoading: true,
    name: 'gambleFuture',
    path: 'atlases/mobileGameImages/gambleFuture.json',
  },
};
export const bitmapFonts = {
  numbersJackpot: {
    isNeedResourceForLoading: true,
    name: 'bit',
    path: 'atlases/bitMapFonts/numbersJackpot.xml',
  },
  fontWildWeenX: {
    isNeedResourceForLoading: true,
    // name: 'bitMap',
    name: 'fontWildWeenX',
    path: 'atlases/bitMapFonts/fontWildWeenX.xml',
  },
};

export const iconsIdByName = {
  [slotBarSymbolNames.seven]: 1,
  [slotBarSymbolNames.grape]: 2,
  [slotBarSymbolNames.watermelon]: 3,
  [slotBarSymbolNames.bell]: 4,
  [slotBarSymbolNames.plum]: 5,
  [slotBarSymbolNames.orange]: 6,
  [slotBarSymbolNames.cherry]: 7,
  [slotBarSymbolNames.lemon]: 8,
  [slotBarSymbolNames.wild]: 9,
  [slotBarSymbolNames.dollar]: 10,
  [slotBarSymbolNames.star]: 11,
};
// export const jackpotBarResources = { todo
//   jackpotActiveColumn: {
//     isNeedResourceForLoading: false,
//     name: winBarWinSceneSpineNames.jackpotActiveColumn,
//     path: 'atlases/columnAnimation/web/skeleton.json',
//     config: {
//       metadata: {
//         spineAtlasFile: 'atlases/columnAnimation/web/skeleton.atlas',
//       },
//     },
//   },
//   jackpotStartPopup: {
//     isNeedResourceForLoading: false,
//     name: winBarWinSceneSpineNames.jackpotStartPopup,
//     path: 'atlases/jackpotAssets/web/jackpotStartPopup/InGame_PopUp.json',
//     config: {
//       metadata: {
//         spineAtlasFile: 'atlases/jackpotAssets/web/jackpotStartPopup/InGame_PopUp.atlas',
//       },
//     },
//   },
//   jackpotGameSceneBoard: {
//     isNeedResourceForLoading: false,
//     name: winBarWinSceneSpineNames.jackpotGameSceneBoard,
//     path: 'atlases/jackpotAssets/web/jackpotBgScene/background_web.json',
//     config: {
//       metadata: {
//         spineAtlasFile: 'atlases/jackpotAssets/web/jackpotBgScene/background_web.atlas',
//       },
//     },
//   },
//   jackpotSymbolContainer: {
//     isNeedResourceForLoading: false,
//     name: winBarWinSceneSpineNames.jackpotSymbolContainer,
//     path: 'atlases/jackpotAssets/web/jackpotSymbolContainer/container.json',
//     config: {
//       metadata: {
//         spineAtlasFile: 'atlases/jackpotAssets/web/jackpotSymbolContainer/container.atlas',
//       },
//     },
//   },
//   jackpotAmountBoard: {
//     isNeedResourceForLoading: false,
//     name: winBarWinSceneSpineNames.jackpotAmountBoard,
//     path: 'atlases/jackpotAssets/web/jackpotAmountBoard/Amount_containers.json',
//     config: {
//       metadata: {
//         spineAtlasFile: 'atlases/jackpotAssets/web/jackpotAmountBoard/Amount_containers.atlas',
//       },
//     },
//   },
//   jackpotIcon: {
//     isNeedResourceForLoading: false,
//     name: winBarWinSceneSpineNames.jackpotIcon,
//     path: 'atlases/jackpotAssets/web/jackpotIcons/jackpotSymbols.json',
//     config: {
//       metadata: {
//         spineAtlasFile: 'atlases/jackpotAssets/web/jackpotIcons/jackpotSymbols.atlas',
//       },
//     },
//   },
//   jackpotWinPopupAnimation: {
//     isNeedResourceForLoading: false,
//     name: winBarWinSceneSpineNames.jackpotWinPopupAnimation,
//     path: 'atlases/jackpotAssets/web/jackpotWinPopupAnimation/win.json',
//     config: {
//       metadata: {
//         spineAtlasFile: 'atlases/jackpotAssets/web/jackpotWinPopupAnimation/win.atlas',
//       },
//     },
//   },
// };
// export const mobileJackpotBarResources = { todo
//   jackpotActiveColumn: {
//     isNeedResourceForLoading: false,
//     name: winBarWinSceneSpineNames.jackpotActiveColumn,
//     path: 'atlases/columnAnimation/mobile/skeleton.json',
//     config: {
//       metadata: {
//         spineAtlasFile: 'atlases/columnAnimation/mobile/skeleton.atlas',
//       },
//     },
//   },
//   jackpotStartPopup: {
//     isNeedResourceForLoading: false,
//     name: winBarWinSceneSpineNames.jackpotStartPopup,
//     path: 'atlases/jackpotAssets/mobile/jackpotStartPopup/InGame_PopUp.json',
//     config: {
//       metadata: {
//         spineAtlasFile: 'atlases/jackpotAssets/mobile/jackpotStartPopup/InGame_PopUp.atlas',
//       },
//     },
//   },
//   jackpotGameSceneBoard: {
//     isNeedResourceForLoading: false,
//     name: winBarWinSceneSpineNames.jackpotGameSceneBoard,
//     path: 'atlases/jackpotAssets/mobile/jackpotBgScene/background_web.json',
//     config: {
//       metadata: {
//         spineAtlasFile: 'atlases/jackpotAssets/mobile/jackpotBgScene/background_web.atlas',
//       },
//     },
//   },
//   jackpotSymbolContainer: {
//     isNeedResourceForLoading: false,
//     name: winBarWinSceneSpineNames.jackpotSymbolContainer,
//     path: 'atlases/jackpotAssets/mobile/jackpotSymbolContainer/container.json',
//     config: {
//       metadata: {
//         spineAtlasFile: 'atlases/jackpotAssets/mobile/jackpotSymbolContainer/container.atlas',
//       },
//     },
//   },
//   jackpotAmountBoard: {
//     isNeedResourceForLoading: false,
//     name: winBarWinSceneSpineNames.jackpotAmountBoard,
//     path: 'atlases/jackpotAssets/mobile/jackpotAmountBoard/Amount_containers.json',
//     config: {
//       metadata: {
//         spineAtlasFile: 'atlases/jackpotAssets/mobile/jackpotAmountBoard/Amount_containers.atlas',
//       },
//     },
//   },
//   jackpotIcon: {
//     isNeedResourceForLoading: false,
//     name: winBarWinSceneSpineNames.jackpotIcon,
//     path: 'atlases/jackpotAssets/mobile/jackpotIcons/jackpotSymbols.json',
//     config: {
//       metadata: {
//         spineAtlasFile: 'atlases/jackpotAssets/mobile/jackpotIcons/jackpotSymbols.atlas',
//       },
//     },
//   },
//   jackpotWinPopupAnimation: {
//     isNeedResourceForLoading: false,
//     name: winBarWinSceneSpineNames.jackpotWinPopupAnimation,
//     path: 'atlases/jackpotAssets/mobile/jackpotWinPopupAnimation/win.json',
//     config: {
//       metadata: {
//         spineAtlasFile: 'atlases/jackpotAssets/mobile/jackpotWinPopupAnimation/win.atlas',
//       },
//     },
//   },
// };

export const slotBarResources = {
  1: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.seven,
    path: 'atlases/slotCharacters/web/symbol1/symbol1.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/symbol1/symbol1.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  2: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.grape,
    path: 'atlases/slotCharacters/web/symbol3/symbol3.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/symbol3/symbol3.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  3: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.watermelon,
    path: 'atlases/slotCharacters/web/symbol4/symbol4.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/symbol4/symbol4.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  4: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.bell,
    path: 'atlases/slotCharacters/web/symbol2/symbol2.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/symbol2/symbol2.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  5: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.plum,
    path: 'atlases/slotCharacters/web/symbol5/symbol5.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/symbol5/symbol5.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  6: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.orange,
    path: 'atlases/slotCharacters/web/symbol6/symbol6.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/symbol6/symbol6.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  7: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.cherry,
    path: 'atlases/slotCharacters/web/symbol7/symbol7.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/symbol7/symbol7.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  8: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.lemon,
    path: 'atlases/slotCharacters/web/symbol8/symbol8.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/symbol8/symbol8.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  9: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.wild,
    path: 'atlases/slotCharacters/web/wild/wild.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/wild/wild.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  10: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.dollar,
    path: 'atlases/slotCharacters/web/scatter1/scatter1.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/scatter1/scatter1.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  11: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.star,
    path: 'atlases/slotCharacters/web/scatter2/scatter2.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/scatter2/scatter2.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  400: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.jackpotSymbol,
    path: 'atlases/slotCharacters/web/jackpotSymbol/skeleton.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/web/jackpotSymbol/skeleton.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  logo: {
    isNeedResourceForLoading: true,
    path: 'atlases/logo/web/logo.json',
    name: 'logo',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/logo/web/logo.atlas',
      },
    },
  },
  slotBoard: {
    isNeedResourceForLoading: true,
    name: 'slotBoard',
    path: 'atlases/slotBoard/web/board.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotBoard/web/board.atlas',
      },
    },
  },
  winCoins: {
    isNeedResourceForLoading: true,
    name: winBarWinSceneSpineNames.winCoins,
    path: 'atlases/winCoins/web/coins.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/winCoins/web/coins.atlas',
      },
    },
  },
  winPopup: {
    isNeedResourceForLoading: true,
    name: winBarWinSceneSpineNames.winPopup,
    path: 'atlases/winPopups/web/winPopups.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/winSymbolBorder/web/winPopups.atlas',
      },
    },
  },
  winningLine: {
    isNeedResourceForLoading: true,
    name: 'winningLine',
    path: 'atlases/winningLine/web/winningLine.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/winningLine/web/winningLine.atlas',
      },
    },
  },
  amountFrame: {
    isNeedResourceForLoading: true,
    name: 'amountFrame',
    path: 'atlases/gambleFuture/web/amountFrame/amount.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/gambleFuture/web/amountFrame/amount.atlas',
      },
    },
  },
  card: {
    name: 'card',
    isNeedResourceForLoading: true,
    path: 'atlases/gambleFuture/web/card/card.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/gambleFuture/web/card/card.atlas',
      },
    },
  },
  symbol: {
    name: 'symbol',
    isNeedResourceForLoading: true,
    path: 'atlases/gambleFuture/web/symbol/symbol.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/gambleFuture/web/symbol/symbol.atlas',
      },
    },
  },
  jackpotActiveColumn: {
    isNeedResourceForLoading: false,
    name: winBarWinSceneSpineNames.jackpotActiveColumn,
    path: 'atlases/columnAnimation/web/skeleton.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/columnAnimation/web/skeleton.atlas',
      },
    },
  },
  jackpotStartPopup: {
    isNeedResourceForLoading: false,
    name: winBarWinSceneSpineNames.jackpotStartPopup,
    path: 'atlases/jackpotAssets/web/jackpotStartPopup/InGame_PopUp.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/web/jackpotStartPopup/InGame_PopUp.atlas',
      },
    },
  },
  jackpotGameSceneBoard: {
    isNeedResourceForLoading: false,
    name: winBarWinSceneSpineNames.jackpotGameSceneBoard,
    path: 'atlases/jackpotAssets/web/jackpotBgScene/background_web.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/web/jackpotBgScene/background_web.atlas',
      },
    },
  },
  jackpotSymbolContainer: {
    isNeedResourceForLoading: false,
    name: winBarWinSceneSpineNames.jackpotSymbolContainer,
    path: 'atlases/jackpotAssets/web/jackpotSymbolContainer/container.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/web/jackpotSymbolContainer/container.atlas',
      },
    },
  },
  jackpotAmountBoard: {
    isNeedResourceForLoading: false,
    name: winBarWinSceneSpineNames.jackpotAmountBoard,
    path: 'atlases/jackpotAssets/web/jackpotAmountBoard/Amount_containers.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/web/jackpotAmountBoard/Amount_containers.atlas',
      },
    },
  },
  jackpotIcon: {
    isNeedResourceForLoading: false,
    name: winBarWinSceneSpineNames.jackpotIcon,
    path: 'atlases/jackpotAssets/web/jackpotIcons/jackpotSymbols.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/web/jackpotIcons/jackpotSymbols.atlas',
      },
    },
  },
  jackpotWinPopupAnimation: {
    isNeedResourceForLoading: false,
    name: winBarWinSceneSpineNames.jackpotWinPopupAnimation,
    path: 'atlases/jackpotAssets/web/jackpotWinPopupAnimation/win.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/web/jackpotWinPopupAnimation/win.atlas',
      },
    },
  },
  wheelLamp: {
    name: winBarWinSceneSpineNames.wheelLamp,
    path: 'atlases/boostedJackpotAtlases/wheelLamp/web/wheelLamp.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/wheelLamp/web/wheelLamp.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  wheelBlueBoard: {
    name: winBarWinSceneSpineNames.wheelBlueBoard,
    path: 'atlases/boostedJackpotAtlases/wheelBlueBoard/web/wheelBlueBoard.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/wheelBlueBoard/web/wheelBlueBoard.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  lightning: {
    name: winBarWinSceneSpineNames.lightning,
    path: 'atlases/boostedJackpotAtlases/lightning/web/lightning.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/lightning/web/lightning.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  wheelSpinIcon: {
    name: winBarWinSceneSpineNames.wheelSpinIcon,
    path: 'atlases/boostedJackpotAtlases/spinButton/web/spinButton.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/spinButton/web/spinButton.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  wheelIcon: {
    name: winBarWinSceneSpineNames.wheelIcon,
    path: 'atlases/boostedJackpotAtlases/wheelIcon/web/wheelIcon1.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/wheelIcon/web/wheelIcon1.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  popup: {
    name: winBarWinSceneSpineNames.popup,
    path: 'atlases/boostedJackpotAtlases/popup/web/popUp.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/popup/web/popUp.atlas',
        imageNamePrefix: '_',
      },
    },
  },
};

export const mobileSlotBarResources = {
  1: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.seven,
    path: 'atlases/slotCharacters/mobile/symbol1/symbol1.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/symbol1/symbol1.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  2: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.grape,
    path: 'atlases/slotCharacters/mobile/symbol3/symbol3.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/symbol3/symbol3.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  3: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.watermelon,
    path: 'atlases/slotCharacters/mobile/symbol4/symbol4.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/symbol4/symbol4.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  4: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.bell,
    path: 'atlases/slotCharacters/mobile/symbol2/symbol2.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/symbol2/symbol2.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  5: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.plum,
    path: 'atlases/slotCharacters/mobile/symbol5/symbol5.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/symbol5/symbol5.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  6: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.orange,
    path: 'atlases/slotCharacters/mobile/symbol6/symbol6.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/symbol6/symbol6.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  7: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.cherry,
    path: 'atlases/slotCharacters/mobile/symbol7/symbol7.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/symbol7/symbol7.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  8: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.lemon,
    path: 'atlases/slotCharacters/mobile/symbol8/symbol8.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/symbol8/symbol8.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  9: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.wild,
    path: 'atlases/slotCharacters/mobile/wild/wild.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/wild/wild.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  10: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.dollar,
    path: 'atlases/slotCharacters/mobile/scatter1/scatter1.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/scatter1/scatter1.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  11: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.star,
    path: 'atlases/slotCharacters/mobile/scatter2/scatter2.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/scatter2/scatter2.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  400: {
    isNeedResourceForLoading: true,
    name: slotBarSymbolNames.jackpotSymbol,
    path: 'atlases/slotCharacters/mobile/jackpotSymbol/skeleton.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotCharacters/mobile/jackpotSymbol/skeleton.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  winPopup: {
    isNeedResourceForLoading: true,
    name: winBarWinSceneSpineNames.winPopup,
    path: 'atlases/winPopups/mobile/winPopups.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/winSymbolBorder/mobile/winPopups.atlas',
      },
    },
  },
  winCoins: {
    isNeedResourceForLoading: true,
    name: winBarWinSceneSpineNames.winCoins,
    path: 'atlases/winCoins/mobile/coins.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/winCoins/mobile/coins.atlas',
      },
    },
  },
  logo: {
    isNeedResourceForLoading: true,
    name: 'logo',
    path: 'atlases/logo/mobile/logo.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/logo/mobile/logo.atlas',
      },
    },
  },
  slotBoard: {
    isNeedResourceForLoading: true,
    path: 'atlases/slotBoard/mobile/board.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/slotBoard/mobile/board.atlas',
      },
    },
  },
  winningLine: {
    isNeedResourceForLoading: true,
    path: 'atlases/winningLine/mobile/winningLine.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/winningLine/mobile/winningLine.atlas',
      },
    },
  },
  amountFrame: {
    isNeedResourceForLoading: true,
    path: 'atlases/gambleFuture/mobile/amountFrame/amount.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/gambleFuture/mobile/amountFrame/amount.atlas',
      },
    },
  },
  card: {
    isNeedResourceForLoading: true,
    path: 'atlases/gambleFuture/mobile/card/card.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/gambleFuture/mobile/card/card.atlas',
      },
    },
  },
  symbol: {
    isNeedResourceForLoading: true,
    path: 'atlases/gambleFuture/mobile/symbol/symbol.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/gambleFuture/mobile/symbol/symbol.atlas',
      },
    },
  },
  jackpotActiveColumn: {
    isNeedResourceForLoading: false,
    name: winBarWinSceneSpineNames.jackpotActiveColumn,
    path: 'atlases/columnAnimation/mobile/skeleton.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/columnAnimation/mobile/skeleton.atlas',
      },
    },
  },
  jackpotStartPopup: {
    isNeedResourceForLoading: false,
    name: winBarWinSceneSpineNames.jackpotStartPopup,
    path: 'atlases/jackpotAssets/mobile/jackpotStartPopup/InGame_PopUp.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/mobile/jackpotStartPopup/InGame_PopUp.atlas',
      },
    },
  },
  jackpotGameSceneBoard: {
    isNeedResourceForLoading: false,
    name: winBarWinSceneSpineNames.jackpotGameSceneBoard,
    path: 'atlases/jackpotAssets/mobile/jackpotBgScene/background_web.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/mobile/jackpotBgScene/background_web.atlas',
      },
    },
  },
  jackpotSymbolContainer: {
    isNeedResourceForLoading: false,
    name: winBarWinSceneSpineNames.jackpotSymbolContainer,
    path: 'atlases/jackpotAssets/mobile/jackpotSymbolContainer/container.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/mobile/jackpotSymbolContainer/container.atlas',
      },
    },
  },
  jackpotAmountBoard: {
    isNeedResourceForLoading: false,
    name: winBarWinSceneSpineNames.jackpotAmountBoard,
    path: 'atlases/jackpotAssets/mobile/jackpotAmountBoard/Amount_containers.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/mobile/jackpotAmountBoard/Amount_containers.atlas',
      },
    },
  },
  jackpotIcon: {
    isNeedResourceForLoading: false,
    name: winBarWinSceneSpineNames.jackpotIcon,
    path: 'atlases/jackpotAssets/mobile/jackpotIcons/jackpotSymbols.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/mobile/jackpotIcons/jackpotSymbols.atlas',
      },
    },
  },
  jackpotWinPopupAnimation: {
    isNeedResourceForLoading: false,
    name: winBarWinSceneSpineNames.jackpotWinPopupAnimation,
    path: 'atlases/jackpotAssets/mobile/jackpotWinPopupAnimation/win.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/jackpotAssets/mobile/jackpotWinPopupAnimation/win.atlas',
      },
    },
  },
  wheelLamp: {
    name: winBarWinSceneSpineNames.wheelLamp,
    path: 'atlases/boostedJackpotAtlases/wheelLamp/mobile/wheelLamp.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/wheelLamp/mobile/wheelLamp.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  wheelBlueBoard: {
    name: winBarWinSceneSpineNames.wheelBlueBoard,
    path: 'atlases/boostedJackpotAtlases/wheelBlueBoard/mobile/wheelBlueBoard.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/wheelBlueBoard/mobile/wheelBlueBoard.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  lightning: {
    name: winBarWinSceneSpineNames.lightning,
    path: 'atlases/boostedJackpotAtlases/lightning/mobile/lightning.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/lightning/mobile/lightning.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  wheelIcon: {
    name: winBarWinSceneSpineNames.wheelIcon,
    path: 'atlases/boostedJackpotAtlases/wheelIcon/mobile/wheelIcon.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/wheelIcon/mobile/wheelIcon.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  wheelSpinIcon: {
    name: winBarWinSceneSpineNames.wheelSpinIcon,
    path: 'atlases/boostedJackpotAtlases/spinButton/mobile/spinButton.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/spinButton/mobile/spinButton.atlas',
        imageNamePrefix: '_',
      },
    },
  },
  popup: {
    name: winBarWinSceneSpineNames.popup,
    path: 'atlases/boostedJackpotAtlases/popup/mobile/popUp.json',
    config: {
      metadata: {
        spineAtlasFile: 'atlases/boostedJackpotAtlases/popup/mobile/popUp.atlas',
        imageNamePrefix: '_',
      },
    },
  },
};

export const resourceCount =
  Object.keys(
    isMobile()
      ? { ...mobileSlotBarResources, ...bitmapFonts }
      : { ...slotBarResources, ...bitmapFonts }
  ).length + Object.keys(isMobile() ? mobileGameImageSprites : webGameImageSprites).length;
export const gameResources = [
  isMobile()
    ? { ...mobileSlotBarResources, ...bitmapFonts }
    : { ...slotBarResources, ...bitmapFonts },
  isMobile() ? mobileGameImageSprites : webGameImageSprites,
];
// export const jackpotResources = [
//   isMobile() ? { ...jackpotBarResources } : { ...jackpotBarResources },
// ];

export const jackpotResources = [];
